export const VENDOR_TYPES = {
  necessary: 'necessary',
  survey: 'survey',
  social: 'social',
  marketing: 'marketing',
  advertisement: 'advertisement'
}

export const COOKIE_TYPES = {
  functional: 'functional',
  statistics: 'statistics',
  marketing: 'marketing'
}
